import { PRODUCT_NAMES } from "@ipru-common/constants/products";
import getSignatureUlipNetCoreInput from "./SignatureNetCoreInput";
import GlobalStore from "@ipru-common/store/GlobalStore";
import { getQdataData, getSelectedFunds, isCustomSavingPage } from "../CommonFunctions";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";

const getSmartKidAssureNetcoreInput = () => {
  const { quoteFormData, calculatorFormData, navFundReleasedCode } = GlobalStore.getSnapshot();
  let smartAssureUserInput = getSignatureUlipNetCoreInput();
  const selectedfunds = quoteFormData?.allocatedFunds ? getSelectedFunds(quoteFormData?.allocatedFunds) : 0;
  const selectedfund = selectedfunds[0] ?? "";
  const data = getQdataData();
  const agentId = data?.agentCode;
  const lmsId = data?.LMS_ID;

  function getMaturityAmount() {
    //Function to extract maturity amount from quoteFormData
    return quoteFormData?.calculatedData?.returns?.pastPerformance?.onlineReturn;
  }
  smartAssureUserInput = {
    ...smartAssureUserInput,
    Child_name: calculatorFormData?.child_name,
    Premium_Waiver: quoteFormData?.premiumWaiver,
    Maturity_Amount: getMaturityAmount(),
  };

  const maturityBenefitValue = quoteFormData?.calculatedData?.returns?.pastPerformance?.onlineReturn;
  if (isCustomSavingPage()) {
    smartAssureUserInput = {
      ...smartAssureUserInput,
      page_title: PRODUCT_NAMES.SmartKidAssure,
      fund_performance_1: selectedfund?.Perf1Year ?? "",
      fund_performance_3: selectedfund?.Perf3Year ?? "",
      fund_performance_5: selectedfund?.Perf5Year ?? "",
      fund_performance_10: selectedfund?.Perf10Year ?? "",
      fund_performance_rsi: selectedfund?.PerfInception ?? "",
      maturity_benefit_1fp: quoteFormData?.returnYears === 1 ? maturityBenefitValue : "",
      maturity_benefit_3fp: quoteFormData?.returnYears === 3 ? maturityBenefitValue : "",
      maturity_benefit_5fp: quoteFormData?.returnYears === 5 ? maturityBenefitValue : "",
      maturity_benefit_10fp: quoteFormData?.returnYears === 10 ? maturityBenefitValue : "",
      maturity_benefit_rsifp: quoteFormData?.returnYears === 1 ? maturityBenefitValue : "",
      swp_opted: quoteFormData?.swpExpand == "Yes" ? "Yes" : "No",
      swp_type_opted: quoteFormData?.swpExpand == "Yes" ? (quoteFormData?.Goal ?? "") : "",
      agentid: agentId,
      lmsid: lmsId,
      trai_flag: "Yes",
      fund_name: selectedfunds?.length > 0 ? selectedfunds[0]?.Fund : (quoteFormData?.selectedFund ?? ""),
      family_income: quoteFormData?.familyIncome,
      premium_waiver_amount: quoteFormData?.premiumWaiver,
      NFOopt: navFundReleasedCode ? String(quoteFormData?.nfoOpt || OPTION_VALUES.N_NO).toLowerCase() : undefined,
    };
  }
  return smartAssureUserInput;
};

export default getSmartKidAssureNetcoreInput;
